<template>
  <div class="thunder" v-show="params.flag">
    <div class="image-player" v-if="thunderData.length > 0">
      <div class="product-name">雷电监测</div>
      <div class="time-node">
        <div :class="{ node: true, active: currentIndex === index }" v-for="(item, index) in times" :key="item"
          @mouseover="handleMouseover(index)"></div>
      </div>
      <div class="show-time">
        {{ $moment(times[currentIndex]).format("HH:mm") }}
      </div>
      <el-button type="primary" :class="{
        'play-bn': true,
        'play-stop': timeout !== '',
        'el-icon-caret-right': timeout === '',
      }" @click="togglePlay">
      </el-button>
    </div>
  </div>
</template>

<script>
import { Vector as VectorLayer } from "ol/layer";
import { Vector as VectorSource } from "ol/source";
import Overlay from "ol/Overlay";
import Feature from "ol/Feature";
import Point from "ol/geom/Point";
import { Style, Icon } from "ol/style";
import { apiData } from "@/api/index";
export default {
  props: ["params"],
  data() {
    return {
      thunderLayer: null,
      thunderSource: null,
      times: [],
      thunderData: [],
      currentIndex: 0,
      timeout: "",
    };
  },
  watch: {
    "params.flag": {
      handler(newVal) {
        if (newVal) {
          this.thunderLayer
            ? this.thunderLayer.setVisible(true)
            : this.getData();
        } else {
          this.thunderLayer && this.thunderLayer.setVisible(false);
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.timmer = setInterval(() => {
      this.getData();
    }, 5000 * 60);
  },
  methods: {
    async getData() {
      const etime = Date.now();
      const result = await apiData.getThunder(this.$moment(etime).format("YYYY-MM-DD HH:mm"));
      this.times = result.data.times;
      this.thunderData = result.data.data;
      if (this.thunderData.length === 0) {
        this.thunderSource && this.thunderSource.clear();
      } else {
        this.currentIndex = result.data.times.length - 1;
        this.drapThunder(this.currentIndex);
      }
    },

    drapThunder(index) {
      if (!this.thunderLayer) {
        this.thunderSource = new VectorSource();
        this.thunderLayer = new VectorLayer({
          zIndex: 999,
          source: this.thunderSource,
        });
        this.params.map2d.map.addLayer(this.thunderLayer);
      }
      const thunderData = this.thunderData[index];
      if (thunderData.length === 0) {
        this.thunderSource.clear();
        this.thunderSource.changed();
      } else {
        this.thunderSource.clear();
        const features = [];
        thunderData.forEach((item) => {
          const positon = [item.lon, item.lat];
          const feature = new Feature({
            geometry: new Point(positon),
            thunderFeatureData: item,
          });
          const src =
            item.intensity >= 0
              ? require("@/assets/images/正闪电.png")
              : require("@/assets/images/负闪电.png");
          const style = new Style({
            image: new Icon({
              src: src,
              anchor: [0.5, 46],
              anchorXUnits: "fraction",
              anchorYUnits: "pixels",
            }),
          });
          feature.setStyle(style);
          feature.set("thunder", true);
          feature.set("data", item);
          features.push(feature);
        });
        this.thunderSource.addFeatures(features);
        this.thunderSource.changed();
      }
    },

    handleMouseover(index) {
      this.currentIndex = index;
      if (this.timeout !== "") {
        clearTimeout(this.timeout);
        this.timeout = "";
      }
      this.drapThunder(index);
    },

    togglePlay() {
      if (this.timeout === "") {
        this.play();
      } else {
        clearTimeout(this.timeout);
        this.timeout = "";
      }
    },

    play() {
      if (this.timeout !== "") {
        clearTimeout(this.timeout);
        this.timeout = "";
      }
      this.timeout = setInterval(() => {
        const index = this.currentIndex + 1;
        if (index === this.times.length) {
          this.currentIndex = 0;
        } else {
          this.currentIndex = index;
        }
        this.drapThunder(index);
      }, 1000);
    },
  },
  beforeDestroy() {
    this.timmer && clearInterval(this.timmer);
  },
};
</script>

<style lang="less" scoped>
.thunder {
  position: absolute;
  right: 0.94vw;
  bottom: 11vh;
  color: #fff;
  box-sizing: border-box;
  border-radius: 0.5rem;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.3);
  background: #fff;
  border-radius: 0.63vw;
  border-bottom-left: 0px;
  border-top-left: 0px;
  opacity: 0.9;
  border: 1px solid #b9a6a6;

  // border-image: linear-gradient(135deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5)) 1 1;
  .image-player {
    display: flex;
    align-items: center;
    padding: 0.1rem 0.5rem 0.1rem 0rem;

    .product-name {
      color: #000;
      border-radius: 0.3rem;
      width: 5rem;
      height: 2rem;
      line-height: 2rem;
      text-align: center;
      padding: 0 0.5rem;
    }

    .time-node {
      display: flex;

      .node {
        height: 1.5rem;
        width: 0.8rem;
        width: 10px;
        background: #364974;
        border-radius: 0.12rem;
        margin-right: 0.2rem;
        cursor: pointer;
        opacity: 0.3;
        display: flex;
        align-items: center;
        justify-content: center;

        .el-icon-loading {
          color: #fff;
          font-size: 0.7rem;
        }
      }

      .node.active {
        background: #7dc5ff;
        opacity: 1;
      }
    }

    .show-time {
      color: #fff;
      background: #526788;
      border-radius: 0.25rem;
      font-size: 1rem;
      text-align: center;
      min-width: 2rem;
      height: 1.5rem;
      line-height: 1.5rem;
      padding: 0 0.5rem;
      margin: 0 0.5rem;
      white-space: nowrap;
    }

    .play-bn {
      padding: 0;
      height: 2rem;
      width: 2rem;
      border-radius: 0.3rem;
      margin: 0 0.5rem 0 0;
      border: none;
      background: #0a5eff;
      color: #fff;
      font-size: 1.25rem;
    }

    .play-stop::before {
      content: "";
      display: block;
      width: 0.7rem;
      height: 0.7rem;
      margin: 0 auto;
      background-color: #fff;
    }

    .speeds-select-bn {
      background: #0a5eff;
      color: #fff;
      height: 2rem;
      width: 4.4rem;
      line-height: 2rem;
      padding: 0 0.5rem;

      i {
        font-size: 1rem;
      }
    }
  }

  .legend {
    display: flex;
    align-items: center;
    color: #fff;
    border-top: 1px solid #dcdfe6;
    padding: 0.1rem 0rem 0.3rem;

    .name {
      color: #fff;
      width: 5rem;
      font-size: 1rem;
      padding: 0 0.5rem;
      text-align: center;
    }

    .nbarwrap {
      .nbar {
        display: flex;
        flex-direction: row;
        justify-content: left;
        font-size: 0.8rem;

        .node {
          display: inline-block;
          height: 1.5rem;
          line-height: 1.5rem;
          width: 1.5rem;
          text-align: center;
        }
      }

      .nbar.bottom {
        .node {
          height: 0.7rem;
        }
      }
    }
  }
}
</style>
